import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppWithCredentials from "./dune/AppWithCredentials";
import AppHostDevelopment from "./dune/AppHostDevelopment";
import { setDebugMode } from "./sw/swClient";
import {
  isDuneDebugEnabled,
  enableDuneDebug,
  disableDuneDebug,
} from "./dune/utils/debugUtils";
import "./index.css";

// Step 1: Register service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("✅ SW registered:", registration);

        // Check if debug mode is enabled in localStorage
        const debugEnabled = isDuneDebugEnabled();
        if (debugEnabled) {
          console.log("🐛 Debug mode enabled from localStorage");
          // Wait for the service worker to be ready
          navigator.serviceWorker.ready.then(() => {
            setDebugMode(true);
          });
        }
      })
      .catch((error) => {
        console.log("❌ SW registration failed:", error);
      });
  });
}

// Helper functions for debug mode
(window as any).enableDuneDebug = () => {
  enableDuneDebug();
  setDebugMode(true);
  console.log(
    "🐛 Dune debug mode enabled. Service worker will log all requests.",
  );
};

(window as any).disableDuneDebug = () => {
  disableDuneDebug();
  setDebugMode(false);
  console.log("🐛 Dune debug mode disabled.");
};

/**
 * Landing component with router
 * Routes to either AppHostDevelopment for development or AppWithCredentials for production apps
 */
const Landing: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/development/:port" element={<AppHostDevelopment />} />
        <Route path="/:appId" element={<AppWithCredentials />} />
      </Routes>
    </BrowserRouter>
  );
};

// Mount the landing component
const container = document.getElementById("root");
if (!container) throw new Error("Fatal: #root element not found.");
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <Landing />
  </React.StrictMode>,
);
